<template>
  <div class="SelectedWebsites">
    <div class="label">
      Geselecteerde module
    </div>

    <div class="selected-wrapper">
      <div v-if="selected && selected.length">
        <PackageItem v-for="web in selected" :key="web.uid"
                     v-bind="web"

                     @click.native="$emit('remove-package', web.uid)"
        >
          <template #before>
            <svg xmlns="http://www.w3.org/2000/svg" class="text-success" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
            </svg>
          </template>
        </PackageItem>
      </div>
      <div v-else>
        <h3>
          Geen module geselecteerd
        </h3>
      </div>
    </div>
  </div>
</template>

<script>

import PackageItem from "./PackageItem.vue"

export default {
  components: {
    PackageItem,
  },
  props: {
    selected: Array,
  },
}

</script>

<style scoped>

.label {
  margin-bottom: 8px;
}

.selected-wrapper {
  border: 1px solid #E3E3E3;
  border-radius: 1px;
  max-height: 200px;
  overflow: auto;
}

h3 {
  text-align: center;
  font-size: 18px;
  margin-bottom: 20px;
  color: #717272;
}

</style>
